import React, { Suspense } from 'react';
import { HashRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import NetworkProvider from './contexts/networkContext';
import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';
import TaskProvider from './contexts/taskContext';
import FocusModeProvider from './contexts/focusModeContext';
import AjaxInterceptors from './utils/AjaxInterceptors';
import AppRoute from './routes/index';
import Loader from './components/Loader/Loader';
import ScrollToTop from './ScrollToTop';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

function App() {
  return (
    <CacheBuster
      currentVersion={version}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<Loader />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <HashRouter>
          <ScrollToTop />
          <CssBaseline />
          <Suspense fallback={<Loader />}>
            <NetworkProvider>
              <TaskProvider>
                <FocusModeProvider>
                  <>
                    <AjaxInterceptors />
                    <AppRoute />
                  </>
                </FocusModeProvider>
              </TaskProvider>
            </NetworkProvider>
          </Suspense>
        </HashRouter>
      </MuiPickersUtilsProvider>
    </CacheBuster>
    // {/* </SnackbarProvider> */}
  );
}

export default App;
